exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.document-title {\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #ddd;\n}\n.document-content h2 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  margin-top: 4rem;\n  border-bottom: 1px solid #eaecef;\n}\n.document-content h2:first-child {\n  margin-top: 0;\n}\n.document-content h2 + h3 {\n  margin-top: 0rem;\n}\n.document-content h3 {\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n", ""]);

// exports
